<!--
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-05-11 09:59:37
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-05-16 16:06:38
 * @FilePath: \Blog.Admin\src\views\TestShow\TestOne.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <el-table :data="tableData" :span-method="spanMethod" border style="width:100%">
            <el-table-column prop="name" :resizable="false" label="名字" align="center"></el-table-column>
            <el-table-column prop="age" :resizable="false" label="年龄" align="center"></el-table-column>
            <el-table-column prop="address" :resizable="false" label="地址" align="center"></el-table-column>
            <el-table-column prop="date" :resizable="false" label="日期" align="center"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button  @click="handleClick(scope.row)" size="small" type="text">点击上传</el-button>
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看文档</el-button>
                    <el-button @click="handleClick(scope.row)" type="text" size="small">自查</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="coClassroom" label="教室" align="center"></el-table-column> -->
        </el-table>
        <el-upload ref="testUpd" v-show="false"  action="http://localhost:9291/images/Upload/Pic" :limit="1"  
                    :on-success="uploadSuccess"
                    :on-error="uploadError">
                        <el-button size="small" type="text">点击上传</el-button>
                    </el-upload>
    </div>
</template>

<script>
import axios from 'axios';
import { Row } from 'element-ui';

export default {
    name: "TestOne",
    data() {
        return {
            tableData: [{
                name: 'John Brown',
                age: 18,
                address: 'New York No. 1 Lake Park',
                date: '2016-10-03',
                column: 2,//第几列需要开始合并
                colSpan: 2,
                rowSpan: 1,
                IsHb: [1]
            },
            {
                name: 'Jim Green',
                age: 24,
                address: 'London No. 1 Lake Park',
                date: '2016-10-01',
                column: 0,//第几列需要开始合并
                colSpan: 1,
                rowSpan: 2,
                IsHb: [0, 1]
            },
            {
                name: 'Joe Black',
                age: 30,
                address: 'Sydney No. 1 Lake Park',
                date: '2016-10-02',
                column: 0,//第几列需要开始合并
                colSpan: 1,
                rowSpan: 1,
                IsHb: [0, 1]
            },
            {
                name: 'Jon Snow',
                age: 26,
                address: 'Ottawa No. 2 Lake Park',
                date: '2016-10-04',
                column: 0,//第几列需要开始合并
                colSpan: 1,
                rowSpan: 1,
                IsHb: []
            }]
        }
    },
    mounted() {
        
        console.log(this.$store.state.testStr);
    },
    methods: {
        handleClick(row) {
            console.log(document.querySelectorAll('input[name="file"]'));
            return document.querySelectorAll('input[name="file"]')[0].click();
        },
        //文件上传事件
      uploadSuccess() {
        this.$refs.testUpd.clearFiles(); //去掉文件列表
      },
      uploadError(){
        this.$refs.testUpd.clearFiles(); //去掉文件列表
      },
        spanMethod({ row, column, rowIndex, columnIndex }) {
            console.log(row, column, rowIndex, columnIndex);
            if (row.IsHb.indexOf(columnIndex) != -1 && row.colSpan != row.rowSpan) {
                //当前索引存在数组里
                if (row.colSpan > row.rowSpan) {
                    return [1, row.colSpan];
                }
                else {
                    return [row.rowSpan, 1];
                }
            }
            else {
                if (row.colSpan > row.rowSpan) {
                    //合并列
                    if (columnIndex >= row.IsHb[0] && columnIndex <= row.colSpan) {
                        return [0, 0];
                    }
                }
                else {
                    if (row.IsHb.indexOf(columnIndex) != -1 && row.colSpan === row.rowSpan && columnIndex === row.IsHb[columnIndex]) {
                        return [0, 0];
                    }
                    else {
                        return [1, 1];
                    }
                }
                return [1, 1];
            }

        }
    }
}
</script>

<style scoped></style>
